import { createFileRoute } from '@tanstack/react-router';

import { collectionQueueScreen, loadCollectionMessages, loadCollectionScreens, queueSearch } from '@/modules/collection/route';
import { lazyScreen } from '@/shared/screen/lazy-screen';

export const Route = createFileRoute('/_app/gestao-carteira/recuperacao/fila')({
  validateSearch: queueSearch,
  staticData: { screen: collectionQueueScreen },
  loader: () => loadCollectionMessages(),
  component: lazyScreen(loadCollectionScreens, 'CollectionQueueRouteScreen'),
});
